export const MDUM_LOAD_PLANS_DETAIL = 'MDUM/LOAD_PLANS_DETAIL'
export const MDUM_LOAD_SERVICE_DETAILS = 'MDUM/MDUM_LOAD_SERVICE_DETAILS'
export const MDUM_LOAD_SERVICE_USAGE = 'MDUM/MDUM_LOAD_SERVICE_USAGE'
export const MOBILE_SERVICES_LIST = 'MOBILE_SERVICES_LIST/LOAD'
export const REQUEST_MOBILE_SERVICES = 'REQUEST_MOBILE_SERVICES'
export const REQUEST_FEATURE_FLAGS = 'REQUEST_FEATURE_FLAGS'
export const MOBILE_SERVICES_DETAIL_STRATEGIC = 'MOBILE_SERVICES_DETAIL_STRATEGIC/LOAD'
export const REQUEST_STRATEGIC_DEVICE_DETAILS = 'REQUEST_STRATEGIC_DEVICE_DETAILS/LOAD'
export const REQUEST_STRATEGIC_SIM_CONFIG_INFO = 'REQUEST_STRATEGIC_SERVICE_INFO/LOAD'
export const REQUESTS_CREATE = 'REQUESTS/CREATE'
export const UPDATE_COVID19_REQUEST_FLAG = 'UPDATE_COVID19_REQUEST_FLAG'
export const REQUEST_PRODUCT_FAMILIES = 'REQUEST_PRODUCT_FAMILIES/LOAD'
export const SERVICE_REQUEST_FETCH_USER_PROFILE = 'SERVICE_REQUEST_FETCH_USER_PROFILE/LOAD'
export const UPDATE_COMPANY_ID = 'UPDATE_COMPANY_ID'
export const UPDATE_SERVICE_NICKNAME = 'UPDATE_SERVICE_NICKNAME'
export const VIEW_SERVICE_NICKNAME = 'VIEW_SERVICE_NICKNAME'
export const REQUEST_CATEGORY_ITEM_QUESTIONS_LOAD = 'REQUEST_CATEGORY_ITEM_QUESTIONS_LOAD'
export const LOAD_MAXIM_ACTIVITIES = 'MAXIM_ACTIVITIES/LOAD'
export const DIRECTORY_LISTING = 'DIRECTORY_LISTING'
export const MOBILE_SERVICE_ETC_LEGACY = 'MOBILE_SERVICE_ETC_LEGACY/LOAD'
